import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {Component} from "../interface/component";
import {ModalService} from "../service/modal";

@injectable()
export class EventsModerationComponent implements Component {

    private $root:JQuery<HTMLElement>;
    private $dismissButtons:JQuery<HTMLElement>;
    @inject(SERVICE_IDENTIFIER.MODAL) public modalService: ModalService;

    init(elem:HTMLElement) {
        this.$root = $(elem);
        this.$dismissButtons = this.$root.find('.js-event-moderation__dismiss');
        this.$dismissButtons.on({ click: this.handleDismissal })
    }

    private handleDismissal = (ev: any) => {
        ev.preventDefault();
        let reasons: any = (<any>window).dismissal_reasons;
        if (undefined !== reasons && Object.keys(reasons).length > 0) {
            let id = $(ev.currentTarget).closest('tr').data('id');
            let select = document.createElement('select');
            let content = document.createElement('div');
            let explaination = document.createElement('p');
            $(explaination).html('You have chosen to disniss this event. Choose the reason from the list below and an email to automatically be sent to the user. <strong>Note that selecting "other" will not trigger an automatic email.</strong>')
            $(content).append(explaination);
            $(select).addClass('form-control');
            Object.keys(reasons).forEach((key, index) => {
                let option = document.createElement('option');
                $(option).attr('value', key);
                $(option).text(reasons[key]);
                $(select).append(option);
            });
            $(content).append(select);
            let $modal = this.modalService.showConfirm(
                'Why is this dismissed?', content, [
                    {
                        label: 'Cancel',
                        class: 'btn-default',
                        events: {
                            click: () => this.modalService.hideConfirm()
                        }
                    },
                    {
                        label: 'Dismiss',
                        class: 'btn-danger',
                        events: {
                            click: () => {
                                let reason = $modal.$element.find('select').val();
                                (<any>window).location = '/admin/events/dismiss?id=' + id + '&reason=' + reason
                            }
                        }
                    }
                ]);
        }
    }
}